import Vue from 'vue';
import Router, { RouterOptions } from 'vue-router';

import { Storage } from '@/enums/storage.enum';
import { mainRoute } from './router/main.route';
import { notFoundRoute } from './router/notFound.route';
import { startRoute } from './router/start.route';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [mainRoute, startRoute, notFoundRoute]
} as RouterOptions);

router.beforeEach((to: any, from: any, next: any) => {
  if (to.matched.some((record: any) => record.meta.authorized)) {
    if (localStorage.getItem(Storage.TOKEN) === null) {
      sessionStorage.setItem(Storage.REDIRECT, JSON.stringify(to));
      next({
        name: 'login'
      });
    } else {
      to.meta.title = process.env.VUE_APP_TITLE;
      // Sprawdzanie roli
      next();
    }
  } else {
    next();
  }
});

export default router;
